export default __webpack_public_path__ + "static/fourth-349bc3164fc2fa8fb7321817a6b019bc.png";